//libraries
import _ from 'lodash';

/**
 * Import all constants as an object.
 */
import * as ActionType from "../../constants/actionType";


var initialState = {
    leftNav: [],
    clientTabs: [],
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export default function (state, action) {
    state = state || initialState;

    switch (action.type) {
        case ActionType.LOAD_NAVIGATION_ROUTES:
            return _.assign({}, state, {
                leftNav: action.payload.leftNav,
                clientTabs: action.payload.clientTabs,
            });

        case ActionType.UN_LOAD_NAVIGATION_ROUTES:
            return _.assign({}, state, {
                leftNav:[],
                clientTabs: [],
            });
        default:
            return state;
    }
}